import 'core-js/stable/number';
import 'core-js/stable/string/repeat';
import Swiper from 'swiper/bundle';

const testimonialSlider = () => {
  new Swiper('#swiper-testimonials', {
    slidesPerView: 2,
    spaceBetween: 40,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // grabCursor: true,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      1: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: true,
        loop: false,
      },
      576: {
        // slidesPerView: 'auto',
        // spaceBetween: 10,
        // centeredSlides: true,
        // loop: false,
        // slidesPerView: 3,
        // spaceBetween: 40,
        // centeredSlides: false,
        // loop: true,
        // // spaceBetween: 20,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 3,
      },
      // when window width is >= 640px
      // 992: {
      //   slidesPerView: 3,
      //   // spaceBetween: 40,
      // },
      1200: {
        slidesPerView: 4,
        // spaceBetween: 40,
      },
      // 1400: {
      //   slidesPerView: 6,
      //   // spaceBetween: 40,
      // },
    },
  });

  new Swiper('#swiper-testimonials-secondary', {
    // Optional parameters
    slidesPerView: 2,
    spaceBetween: 40,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // grabCursor: true,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      1: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: true,
        loop: false,
      },
      768: {},
    },
  });
};

export default testimonialSlider;